import { render } from "./FrmExpeditionDocumentAddPaleNoSales.vue?vue&type=template&id=00a70b06"
import script from "./FrmExpeditionDocumentAddPaleNoSales.vue?vue&type=script&lang=js"
export * from "./FrmExpeditionDocumentAddPaleNoSales.vue?vue&type=script&lang=js"

import "./FrmExpeditionDocumentAddPaleNoSales.vue?vue&type=style&index=0&id=00a70b06&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__